import { PublishedWithChanges } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';
import InfoIcon from '@mui/icons-material/Info';
import {
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import ModalPreVisualizacaoCertidao from '@/components/ModalPreVisualizacaoCertidao';
import SituacaoJulgamentoProcessoBusiness from '@/dominio/SituacaoJulgamentoProcessoBusiness';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { Fragment } from 'react';
import Signatario from '../certidao/Signatario';
import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import FiltroRapido from './FiltroRapido';
import OperacoesEmLoteSelecionar from './OperacoesEmLoteSelecionar';
import PainelProcessosOperacoesEmLote from './PainelProcessosOperacoesEmLote';

class RepublicarPautaLote extends ReactComponent {
    dialogListagemOpen = false;
    dialogConfirmacaoOpen = false;
    carregando = false;
    carregandoPreVisualizacao = false;
    carregandoPreVisualizacaoCertidao = false;
    dataLimitePublicacao;
    dataLimiteDisponibilizacao;
    dataLimiteEnvio;
    dataDisponibilizacao;
    dataProximaDisponibilizacao;
    dataPublicacao;
    cpfSignatario;
    errosValidacaoFechamento = [];
    codigoOTP;
    previaPublicacaoHTML = '';
    previaCertidaoHTML = '';
    openDialog = false;
    openModalCertidao = false;
    cabecalhoPublicacao;
    confirmarPublicarDiario = true;
    enviarCertidao = true;

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogListagemOpen: observable,
            dialogConfirmacaoOpen: observable,
            carregando: observable,
            carregandoPreVisualizacao: observable,
            carregandoPreVisualizacaoCertidao: observable,
            dataLimitePublicacao: observable,
            dataLimiteDisponibilizacao: observable,
            dataLimiteEnvio: observable,
            dataDisponibilizacao: observable,
            dataProximaDisponibilizacao: observable,
            dataPublicacao: observable,
            cpfSignatario: observable,
            errosValidacaoFechamento: observable,
            codigoOTP: observable,
            previaPublicacaoHTML: observable,
            previaCertidaoHTML: observable,
            openDialog: observable,
            openModalCertidao: observable,
            cabecalhoPublicacao: observable,
            confirmarPublicarDiario: observable,
            enviarCertidao: observable,
            handleClickIcone: action,
            handleCloseDialog: action,
            handleCloseDialogConfirmacao: action,
            handleConfirmarRepublicar: action,
            datasPreVisualizacaoCertidao: computed,
            publicarPautaDto: computed,
            processosConfirmacao: computed,
            processosRepublicacao: computed,
            handleChangeCodigoOTP: action,
            isPeriodoPautaEncerrado: computed,
            callbackAlterarCpfSignatario: action,
            quantidadeProcessosSelecionados: computed,
            desabilitarPublicar: computed,
            handleChangeDataDisponibilizacao: action,
            handleChangeDataPublicacao: action,
            limparProcessoPesquisa: action,
            processos: computed,
            processosSelecionados: computed,
            existeProcessoParaRepublicacao: computed,
            quantidadeProcessosRepublicacao: computed,
            pautaExclusivamenteVirtual: computed,
            pautaExclusivamentePresencial: computed,
            mensagemLoteSemProcessos: computed,
            handleClickConfirmar: action,
            abrirModalVisualizacaoCertidao: action,
            handleCloseModalCertidao: action,
            handleCabecalhoPublicacao: action,
            renderConteudo: computed,
            desabilitarConfirmar: computed,
            mensagemConfirmacaoPublicacaoDiario: computed,
            handleChangeConfirmarPublicarDiario: action,
            handleChangeEnviarCertidao: action,
            mensagemValidacaoDataDisponibilizacao: computed
        });
    }

    handleClickIcone = async () => {
        this.dialogListagemOpen = true;
        this.carregarSignatario();
        this.limparProcessoPesquisa();
    };

    handleCloseDialog = () => {
        this.dialogListagemOpen = false;
    };

    handleCloseDialogConfirmacao = () => {
        this.dialogConfirmacaoOpen = false;
    };

    handleConfirmarRepublicar = async () => {
        await this.pautaJulgamentoStore.processarLote({
            titulo: 'Republicar processos',
            indeterminate: true,
            qtdTotalProcessos: this.processosConfirmacao.length,
            lotesProcessos: [this.processosConfirmacao],
            funcaoOperacao: this.confirmarPublicarPauta
        });
        this.handleCloseDialogConfirmacao();
        await this.sessaoStore.recarregarListaProcessos();
    };

    confirmarPublicarPauta = async () => {
        const resultado = await this.sessaoService.confirmarPublicarPauta(
            this.pautaJulgamentoStore.idPautaSelecionada,
            this.publicarPautaDto,
            this.enviarCertidao,
            this.confirmarPublicarDiario,
            true
        );
        this.pautaJulgamentoStore.atualizarProcessamentoLote(resultado);
        return resultado;
    };

    get datasPreVisualizacaoCertidao() {
        const datasPreVisualizacaoCertidao = {
            dataDisponibilizacao: this.dataDisponibilizacao.format('YYYY-MM-DD'),
            dataPublicacao: this.dataPublicacao.format('YYYY-MM-DD')
        };

        return datasPreVisualizacaoCertidao;
    }

    get publicarPautaDto() {
        const publicarPautaDto = {
            dataDisponibilizacao: this.dataDisponibilizacao.format('YYYY-MM-DD'),
            dataPublicacao: this.dataPublicacao.format('YYYY-MM-DD'),
            otp: this.codigoOTP,
            cpfSignatario: this.cpfSignatario,
            processosConfirmacao: this.processosConfirmacao,
            cabecalhoPublicacao: this.cabecalhoPublicacao,
            tipoPublicacao: 'PAUTA'
        };

        return publicarPautaDto;
    }

    get mensagemSucesso() {
        return this.processosSelecionados.length > 1
            ? 'Processos republicados com sucesso'
            : 'Processo republicado com sucesso';
    }

    get processosConfirmacao() {
        return this.processosSelecionados.map((registro) => ({
            numero: registro.processo.numeroCompleto,
            publicar: this.store.isCheckedOperacoesEmLote(registro),
            confirmar: false
        }));
    }

    get processosRepublicacao() {
        return this.processosSelecionados.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    handleChangeCodigoOTP = (event) => {
        this.codigoOTP = event.target.value;
        this.codigoOTP = this.codigoOTP.toString();
    };

    carregar = async () => {
        runInAction(() => (this.carregando = true));

        if (this.sessao) {
            const prazos = await this.sessaoService.recuperarPrazosPublicacaoPauta(
                this.pautaJulgamentoStore.getDataInicioJulgamento()
            );
            runInAction(() => {
                this.dataLimitePublicacao = moment(prazos.dataLimitePublicacao, 'DD-MM-YYYY-HH-mm-ss', true);
                this.dataLimiteDisponibilizacao = moment(
                    prazos.dataLimiteDisponibilizacao,
                    'DD-MM-YYYY-HH-mm-ss',
                    true
                );
                this.dataLimiteEnvio = moment(prazos.dataLimiteEnvio, 'DD-MM-YYYY-HH-mm-ss', true);
                this.dataDisponibilizacao = moment(prazos.dataProximaDisponibilizacao, 'DD-MM-YYYY-HH-mm-ss', true);
                this.dataProximaDisponibilizacao = moment(
                    prazos.dataProximaDisponibilizacao,
                    'DD-MM-YYYY-HH-mm-ss',
                    true
                );
                this.dataPublicacao = moment(prazos.dataProximaPublicacao, 'DD-MM-YYYY-HH-mm-ss', true);
            });
            const cabecalhoPublicacao = await this.sessaoService.buscarCabecalhoPulicacaoPauta(
                this.pautaJulgamentoStore.idPautaSelecionada
            );
            runInAction(() => (this.cabecalhoPublicacao = cabecalhoPublicacao));
        }
        runInAction(() => (this.carregando = false));
    };

    get isPeriodoPautaEncerrado() {
        return this.existeProcessoParaRepublicacao && moment().isAfter(this.dataLimiteEnvio);
    }

    carregarSignatario() {
        if (this.sessao.orgaoJudicante) {
            this.cpfSignatario = this.dominioStore.temSignatariosCadastradosOjc(this.sessao.orgaoJudicante.sigla)
                ? this.dominioStore.signatarioCadastradoDefaultOjc(this.sessao.orgaoJudicante.sigla).cpf
                : this.usuarioStore.usuario.cpf;
        } else {
            this.cpfSignatario = this.usuarioStore.usuario.cpf;
        }
    }

    callbackAlterarCpfSignatario(cpfSignatario) {
        this.cpfSignatario = cpfSignatario;
    }

    get sessao() {
        return this.pautaJulgamentoStore.sessaoSelecionada;
    }

    get quantidadeProcessosSelecionados() {
        return this.processosSelecionados.length;
    }

    quantidadeProcessosPorTipoInclusao(tipoInclusao) {
        return this.processosSelecionados.filter((processo) => processo.tipoInclusao === tipoInclusao).length;
    }

    get desabilitarPublicar() {
        return !this.existeProcessoParaRepublicacao;
    }

    formatarValorData(value) {
        const novoValor = value
            ? moment(value.format('DD-MM-YYYY') + '-' + moment().format('HH-mm-ss'), 'DD-MM-YYYY-HH-mm-ss')
            : value;
        return novoValor;
    }

    handleChangeDataDisponibilizacao = async (value) => {
        this.dataDisponibilizacao = this.formatarValorData(value);

        if (this.dataDisponibilizacao) {
            const prazos = await this.sessaoService.recuperarPrazosPublicacaoPauta(
                this.pautaJulgamentoStore.getDataInicioJulgamento(),
                this.dataDisponibilizacao.format('DD-MM-YYYY-HH-mm-ss')
            );
            runInAction(() => {
                this.dataPublicacao = moment(prazos.dataProximaPublicacao, 'DD-MM-YYYY-HH-mm-ss', true);
                this.dataDisponibilizacao = moment(prazos.dataProximaDisponibilizacao, 'DD-MM-YYYY-HH-mm-ss', true);
            });
        }
    };

    handleChangeDataPublicacao = (value) => {
        this.dataPublicacao = this.formatarValorData(value);
    };

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    get processos() {
        return (this.pautaJulgamentoStore.processosPautaSelecionadaFiltrados || []).filter(
            (registro) => registro.confirmadaPublicacaoPauta && this.filtrarProcessoPeloNumero(registro)
        );
    }

    get processosSelecionados() {
        return this.processosSelecionaveis.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    get existeProcessoParaRepublicacao() {
        return this.quantidadeProcessosRepublicacao > 0;
    }

    get quantidadeProcessosRepublicacao() {
        return this.processosRepublicacao.length;
    }

    get pautaExclusivamenteVirtual() {
        return (
            this.sessaoStore.sessaoSelecionada &&
            SituacaoJulgamentoProcessoBusiness.isProcessoPautadoEmJulgamentoExclusivamenteVirtual(
                this.sessaoStore.sessaoSelecionada.tipoJulgamento
            )
        );
    }

    get pautaExclusivamentePresencial() {
        return SituacaoJulgamentoProcessoBusiness.isJulgamentoExclusivamentePresencial(
            this.sessaoStore?.sessaoSelecionada
        );
    }

    get processosSelecionaveis() {
        return this.processos.filter((registro) => registro.confirmadaPublicacaoPauta);
    }

    get mensagemLoteSemProcessos() {
        return 'Não há processos para republicar' + this.complementoMensagemFiltrando;
    }

    handleClickConfirmar = async () => {
        this.dialogConfirmacaoOpen = true;
        await this.carregar();
    };

    abrirModalVisualizacaoCertidao = () => {
        this.openModalCertidao = true;
    };

    handleCloseModalCertidao = () => {
        this.openModalCertidao = false;
    };

    handleCabecalhoPublicacao = (event) => {
        this.cabecalhoPublicacao = event.target.value;
    };

    render() {
        return (
            <>
                <div
                    className="corBotao"
                    style={{ marginRight: '10px', paddingLeft: '5px' }}
                >
                    <Tooltip
                        placement="top-start"
                        title={'Republicar processos da pauta'}
                    >
                        <PublishedWithChanges
                            onClick={this.handleClickIcone}
                            style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                        />
                    </Tooltip>
                </div>
                {!!this.dialogListagemOpen && (
                    <Dialog
                        fullWidth
                        open
                        maxWidth="xl"
                        onClose={this.handleCloseDialog}
                        PaperProps={{ style: { height: '100%' } }}
                    >
                        <DialogTitle>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                        flexGrow: 1
                                    }}
                                >
                                    <h4 style={{ margin: '0px' }}>Republicar processos</h4>
                                    <div style={{ margin: '0px 10px' }}>
                                        <NumeroProcesso
                                            dense
                                            callbackOnChange={this.callbackNumeroProcesso}
                                            clickLimpar={this.limparProcessoPesquisa}
                                            tooltip="Número do processo a ser pesquisado na listagem"
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                margin: '10px',
                                                paddingTop: '5px'
                                            }}
                                        >
                                            <PainelFiltros />
                                        </div>
                                        <FiltroRapido id="filtroRapidoConfirmarPublicarProcessosLote" />
                                    </div>
                                </div>
                            </div>
                        </DialogTitle>
                        {this.renderConteudo}
                    </Dialog>
                )}
                {this.renderDialogConfirmacao()}
            </>
        );
    }

    get renderConteudo() {
        return this.sessaoStore.carregandoProcessos ? (
            <div style={{ display: 'flex' }}>
                <CircularProgress
                    disableShrink
                    style={{ margin: '20px' }}
                />
                <Typography
                    style={{ margin: '25px 10px' }}
                    variant="h6"
                >
                    Carregando processos...
                </Typography>
            </div>
        ) : (
            <>
                <OperacoesEmLoteSelecionar
                    processos={this.processos}
                    processosSelecionaveis={this.processosSelecionaveis}
                />
                <PainelProcessosOperacoesEmLote
                    mensagemLoteSemProcessos={this.mensagemLoteSemProcessos}
                    processos={this.processos}
                />
                <DialogActions>
                    <Button
                        color="secondary"
                        endIcon={<CancelIcon />}
                        onClick={this.handleCloseDialog}
                        variant="outlined"
                    >
                        Fechar
                    </Button>
                    <Button
                        color="primary"
                        disabled={!this.processosSelecionados || this.processosSelecionados.length === 0}
                        endIcon={<CheckIcon />}
                        onClick={this.handleClickConfirmar}
                        variant="outlined"
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </>
        );
    }

    renderDialogConfirmacao() {
        return (
            this.dialogConfirmacaoOpen && (
                <Dialog
                    fullWidth
                    open
                    maxWidth="md"
                >
                    <DialogTitle>Republicar processos</DialogTitle>
                    <DialogContent>
                        {this.carregando ? (
                            <CircularProgress
                                disableShrink={true}
                                style={{ margin: '10px' }}
                            />
                        ) : (
                            this.renderConteudoConfirmacao()
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="secondary"
                            endIcon={<CancelIcon />}
                            onClick={this.handleCloseDialogConfirmacao}
                            variant="outlined"
                        >
                            Fechar
                        </Button>
                        <Tooltip
                            placement="top-start"
                            title={this.getTooltipBotaoConfirmar()}
                        >
                            <div>
                                <Button
                                    color="primary"
                                    disabled={this.desabilitarConfirmar}
                                    endIcon={<CheckIcon />}
                                    onClick={this.handleConfirmarRepublicar}
                                    variant="outlined"
                                >
                                    Confirmar
                                </Button>
                            </div>
                        </Tooltip>
                    </DialogActions>
                </Dialog>
            )
        );
    }

    getTooltipBotaoConfirmar() {
        if (this.existeProcessoParaRepublicacao && this.mensagemValidacaoDataDisponibilizacao) {
            return this.mensagemValidacaoDataDisponibilizacao;
        }
        return this.existeProcessoParaRepublicacao && !this.isPeriodoPautaEncerrado ? 'Preencha todos os campos' : '';
    }

    get desabilitarConfirmar() {
        return (
            !this.dataDisponibilizacao ||
            (this.existeProcessoParaRepublicacao && this.enviarCertidao && !this.isStringPreenchida(this.codigoOTP))
        );
    }

    get mensagemConfirmacaoPublicacaoDiario() {
        return this.confirmarPublicarDiario
            ? 'A Secretaria Eletrônica enviará o tipo de comunicação Intimação ao DJEN e registrará NOVOS movimentos de disponibilização e publicação no sistema de origem.'
            : 'A Secretaria Eletrônica registrará os NOVOS movimentos de disponibilização e publicação no sistema de origem SEM o envio do tipo de comunicação Intimação ao DJEN.';
    }

    isStringPreenchida(string) {
        return string && (string + '').trim() !== '';
    }

    renderConteudoConfirmacao() {
        return (
            <>
                {this.renderAlertaGeral()}
                {this.renderErros()}
                {!!this.existeProcessoParaRepublicacao && (
                    <>
                        {this.renderDatasLimites()}
                        {this.renderDataDisponibilizacaoDataPublicacao()}
                        {this.renderConfirmarPublicarDiario()}
                        {this.renderCamposPublicacao()}
                    </>
                )}
            </>
        );
    }

    renderConfirmarPublicarDiario() {
        return (
            <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0px', marginLeft: '8px' }}>
                <Typography
                    color="primary"
                    style={{ marginRight: '42px', whiteSpace: 'nowrap', textAlign: 'right', width: '125px' }}
                    variant="subtitle1"
                >
                    <b>Reenviar para o DJEN</b>
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <div style={{ width: '100%' }}>
                        <Checkbox
                            checked={this.confirmarPublicarDiario}
                            onChange={this.handleChangeConfirmarPublicarDiario}
                            style={{ padding: '4px' }}
                        />
                        <IconButton
                            aria-label={this.mensagemConfirmacaoPublicacaoDiario}
                            color="inherit"
                            size="large"
                            style={{ width: '50px' }}
                        >
                            <Tooltip title={this.mensagemConfirmacaoPublicacaoDiario}>
                                <InfoIcon style={{ color: '#01579b' }} />
                            </Tooltip>
                        </IconButton>
                    </div>
                </div>
            </div>
        );
    }

    handleChangeConfirmarPublicarDiario = () => {
        this.confirmarPublicarDiario = !this.confirmarPublicarDiario;
    };

    handleChangeEnviarCertidao = () => {
        this.enviarCertidao = !this.enviarCertidao;
    };

    getMinDate() {
        return this.confirmarPublicarDiario
            ? this.dataProximaDisponibilizacao
            : this.dataProximaDisponibilizacao.subtract(30, 'days');
    }

    renderDataDisponibilizacaoDataPublicacao() {
        return (
            <>
                <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0px', paddingLeft: '10px' }}>
                    <Typography
                        color="primary"
                        style={{ paddingRight: '15px', whiteSpace: 'nowrap', textAlign: 'center' }}
                        variant="subtitle1"
                    >
                        <b>Data disponibilização</b>
                    </Typography>
                    <DatePicker
                        slotProps={{
                            textField: {
                                helperText: this.mensagemValidacaoDataDisponibilizacao
                            }
                        }}
                        disablePast={this.confirmarPublicarDiario}
                        minDate={this.getMinDate()}
                        onChange={this.handleChangeDataDisponibilizacao}
                        value={this.dataDisponibilizacao}
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0px', paddingLeft: '50px' }}>
                    <Typography
                        color="primary"
                        style={{ paddingRight: '15px', whiteSpace: 'nowrap', textAlign: 'center' }}
                        variant="subtitle1"
                    >
                        <b>Data publicação</b>
                    </Typography>
                    <DatePicker
                        minDate={
                            this.dataDisponibilizacao ? this.dataDisponibilizacao.clone().add(1, 'days') : undefined
                        }
                        disablePast={this.confirmarPublicarDiario}
                        onChange={this.handleChangeDataPublicacao}
                        value={this.dataPublicacao}
                    />
                </div>
            </>
        );
    }

    get mensagemValidacaoDataDisponibilizacao() {
        if (!this.dataDisponibilizacao) {
            return 'Data não informada ou inválida';
        }

        if (!this.dataDisponibilizacao.isValid()) {
            return 'A data informada é inválida';
        }

        if (this.dataDisponibilizacao.isBefore(this.dataProximaDisponibilizacao)) {
            return 'A data informada é anterior à data limite.';
        }

        if (this.dataDisponibilizacao.isAfter(this.dataLimiteDisponibilizacao)) {
            return 'A data informada é posterior à data limite.';
        }

        return null;
    }

    renderDatasLimites() {
        return (
            <>
                <div style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                    <Typography display="inline">
                        <b>Data limite para envio: </b>
                        {this.dataLimiteEnvio ? this.dataLimiteEnvio.format('DD/MM/YYYY HH:mm') : null}
                    </Typography>
                </div>
                <div style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                    <Typography display="inline">
                        <b>Data limite para disponibilização: </b>
                        {this.dataLimiteDisponibilizacao ? this.dataLimiteDisponibilizacao.format('DD/MM/YYYY') : null}
                    </Typography>
                </div>
                <div style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                    <Typography display="inline">
                        <b>Data limite para publicação: </b>
                        {this.dataLimitePublicacao ? this.dataLimitePublicacao.format('DD/MM/YYYY') : null}
                    </Typography>
                </div>
            </>
        );
    }

    renderCabecalhoPublicacao() {
        return (
            <div style={{ marginBottom: '15px', marginTop: '15px', marginLeft: '30px' }}>
                <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0px', paddingLeft: '10px' }}>
                    <Typography
                        color="primary"
                        style={{ paddingRight: '15px', whiteSpace: 'nowrap', textAlign: 'center' }}
                        variant="subtitle1"
                    >
                        <b>Texto Publicação</b>
                    </Typography>
                    <TextField
                        fullWidth={true}
                        id={'cabecalhoPublicacao'}
                        maxRows={15}
                        multiline={true}
                        onChange={this.handleCabecalhoPublicacao}
                        size={'small'}
                        value={this.cabecalhoPublicacao}
                        variant="outlined"
                    />
                </div>
            </div>
        );
    }

    renderCamposPublicacao() {
        return (
            <>
                <div style={{ marginLeft: '81px' }}>
                    <Signatario
                        callbackAlterarCpfSignatario={this.callbackAlterarCpfSignatario.bind(this)}
                        cpfSignatario={this.cpfSignatario}
                    />
                </div>
                {!this.desabilitarPublicar && (
                    <>
                        {!!this.confirmarPublicarDiario && (
                            <>
                                {this.renderCabecalhoPublicacao()}
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        margin: '3px 0px',
                                        marginLeft: '70px'
                                    }}
                                >
                                    <Typography
                                        style={{
                                            marginRight: '15px',
                                            whiteSpace: 'nowrap',
                                            textAlign: 'right',
                                            width: '110px'
                                        }}
                                        color="primary"
                                        variant="subtitle1"
                                    >
                                        <b>{'Publicador'}</b>
                                    </Typography>
                                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                        <div style={{ width: '100%' }}>
                                            <TextField
                                                disabled
                                                fullWidth={true}
                                                id={'teste'}
                                                margin={'dense'}
                                                size={'small'}
                                                value={this.usuarioStore.usuario.nome}
                                                variant="outlined"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    margin: '3px 0px',
                                    marginLeft: '60px'
                                }}
                            >
                                <Typography
                                    style={{
                                        marginRight: '15px',
                                        whiteSpace: 'nowrap',
                                        textAlign: 'left',
                                        width: '100px'
                                    }}
                                    color="primary"
                                    variant="subtitle1"
                                >
                                    <b>Gerar certidão</b>
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                        <Checkbox
                                            checked={this.enviarCertidao}
                                            onChange={this.handleChangeEnviarCertidao}
                                            style={{ padding: '4px' }}
                                        />
                                        <ModalPreVisualizacaoCertidao
                                            callbackAbrirModal={this.abrirModalVisualizacaoCertidao}
                                            callbackCancelar={this.handleCloseModalCertidao}
                                            datasPreVisualizacaoCertidao={this.datasPreVisualizacaoCertidao}
                                            enviarCertidao={this.enviarCertidao}
                                            existeProcessoParaPublicacao={this.existeProcessoParaRepublicacao}
                                            idPautaSelecionada={this.pautaJulgamentoStore.idPautaSelecionada}
                                            openModalCertidao={this.openModalCertidao}
                                            processosConfirmacaoPublicacao={this.processosRepublicacao}
                                        />
                                        <IconButton
                                            aria-label="Gerar certidão"
                                            color="inherit"
                                            size="large"
                                            style={{ width: '50px' }}
                                        >
                                            <Tooltip
                                                title={
                                                    this.enviarCertidao
                                                        ? 'Incluir certidão de inclusão em pauta para os processos selecionados.'
                                                        : ' NÃO haverá a anexação de certidão de inclusão em pauta nos processos selecionados'
                                                }
                                            >
                                                <InfoIcon style={{ color: '#01579b' }} />
                                            </Tooltip>
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                            {this.enviarCertidao ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        margin: '3px 0px',
                                        marginLeft: '70px'
                                    }}
                                >
                                    <Typography
                                        style={{
                                            marginRight: '15px',
                                            whiteSpace: 'nowrap',
                                            textAlign: 'right',
                                            width: '95px'
                                        }}
                                        color="primary"
                                        variant="subtitle1"
                                    >
                                        <b>{'Código OTP'}</b>
                                    </Typography>
                                    <div style={{ display: 'flex', alignItems: 'center', width: '40%' }}>
                                        <div style={{ width: '100%' }}>
                                            <TextField
                                                disabled={this.desabilitarPublicar}
                                                fullWidth={true}
                                                id={'idCodigoOTP'}
                                                margin={'dense'}
                                                onChange={this.handleChangeCodigoOTP}
                                                size={'small'}
                                                type="number"
                                                variant="outlined"
                                            />
                                        </div>
                                        <div>
                                            <IconButton
                                                aria-label="Codigo OTP"
                                                color="inherit"
                                                size="large"
                                                style={{ width: '50px' }}
                                            >
                                                <Tooltip
                                                    title={
                                                        'Código OTP gerado pelo aplicativo JTe. Será utilizado para assinatura das certidões de inclusão em pauta geradas nos processos que forem publicados.'
                                                    }
                                                >
                                                    <InfoIcon style={{ color: '#01579b' }} />
                                                </Tooltip>
                                            </IconButton>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </>
                    </>
                )}
            </>
        );
    }

    renderErros() {
        return (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
                {this.isPeriodoPautaEncerrado ? (
                    <div style={{ color: 'orange', marginBottom: '15px', paddingLeft: '10px' }}>
                        <Typography
                            fontWeight="bold"
                            style={{ marginBottom: '4px' }}
                        >
                            <b>Atenção: Período para envio da pauta encerrado.</b>
                        </Typography>
                    </div>
                ) : null}
            </>
        );
    }

    renderAlertaGeral() {
        return (
            <div style={{ color: 'orange', marginBottom: '15px', paddingLeft: '10px' }}>
                <Typography
                    fontWeight="bold"
                    style={{ marginBottom: '4px' }}
                >
                    Atenção: Serão enviadas novas publicações para processos já publicados.
                </Typography>
            </div>
        );
    }
}

export default inject('stores')(observer(RepublicarPautaLote));
